import React from "react";
import { useMount } from "react-use";
import { ProcessTreeItem as IProcessTreeItem } from "../../../../@types/common";
import useBehaviorContext from "./hooks/useBehaviorContext";
import { createTree } from "./utils";

type ProcessTreeProps = {
  className: string;
  data: Array<IProcessTreeItem>;
  showAdditionalInfo?: boolean;
};

const ProcessTree: React.FC<ProcessTreeProps> = ({
  data,
  className,
  showAdditionalInfo = true
}) => {
  const { setActive } = useBehaviorContext();

  useMount(() => {
    const firstElement = data?.slice(0).pop();
    setActive(firstElement);
  });

  return <ul className={className}>{createTree(data, showAdditionalInfo)}</ul>;
};

export default ProcessTree;
